import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-more-menu",
  "use": "icon-more-menu-usage",
  "viewBox": "0 0 16 12.481",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 12.481\" id=\"icon-more-menu\">\n    <path fill=\"currentColor\" d=\"M.918,12.481a1.022,1.022,0,0,1,0-2.033H15.081a1.022,1.022,0,0,1,0,2.033Zm0-5.224A.972.972,0,0,1,0,6.24.972.972,0,0,1,.918,5.224H15.081A.972.972,0,0,1,16,6.24a.972.972,0,0,1-.919,1.017Zm0-5.224A.972.972,0,0,1,0,1.017.972.972,0,0,1,.918,0H15.081A.972.972,0,0,1,16,1.017a.972.972,0,0,1-.919,1.017Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol